/**
 * Flatlogic Dashboards (https://flatlogic.com/admin-dashboards)
 *
 * Copyright © 2015-present Flatlogic, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from "react";
import cx from "classnames";
import { Switch, Route, withRouter } from "react-router-dom";

import s from "./Layout.module.scss";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import Sidebar from "../Sidebar";

// Dashboard component is loaded directly as an example of server side rendering
import Buttons from "../../pages/buttons/Buttons";
import Charts from "../../pages/charts/Charts";
import Maps from "../../pages/google/Google";
import NotFound from "../../pages/notFound/NotFound";
import Tables from "../../pages/archive/tables/Tables";
import Notifications from "../../pages/archive/notifications/Notifications";
//import Posts from '../../pages/posts'
//import Privacy from '../../pages/privacy'
//import Icons from '../../pages/icons'
//import Typography from '../../pages/typography'

const HeaderWrapper = withRouter((props) => <Header {...props} />);

class Layout extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      sidebarOpen: false,
    };
  }

  render() {
    return (
      <div className={s.root}>
        <Sidebar links={this.props.sidebarMenu} />
        <div
          className={cx(s.wrap, {
            [s.sidebarOpen]: this.state.sidebarOpen,
          })}
        >
          <HeaderWrapper
            sidebarToggle={() =>
              this.setState({
                sidebarOpen: !this.state.sidebarOpen,
              })
            }
          />
          <main className={s.content}>
            <Switch>
              {this.props.routes.map((route, idx) => (
                <Route path={route.path} exact component={route.component} render={route.render} key={idx} />
              ))}

              {/*
                <Route path="/app/typography" exact component={Typography} />
                <Route path="/app/posts" component={Posts} />
                <Route path="/app/privacy" exact component={Privacy} />

              <Route path="/app/components/icons" exact component={Icons} />
                            */}
              <Route path="/app/notifications" exact component={Notifications} />
              <Route path="/app/tables" exact component={Tables} />
              <Route path="/app/components/buttons" exact component={Buttons} />
              <Route path="/app/components/maps" exact component={Maps} />
              <Route path="/app/components/charts" exact component={Charts} />
              <Route component={NotFound} />
            </Switch>
          </main>
          <Footer />
        </div>
      </div>
    );
  }
}

export default withRouter(Layout);
